import { desktopBridge } from './bridge';

/**
 * WILL THE SHELL DRAW A BANNER? ("Native notifications" in desktop settings.)
 *
 * The toggle reads "Use your operating system's banners instead of in-app
 * popups" - but only the SHELL knew its value. The page went on handing every
 * banner to the shell and skipping its own popup, the shell dropped it because
 * the toggle was off, and nothing was drawn by anybody: turning the switch off
 * silenced every message, mention, meeting and reminder banner on the desktop.
 *
 * Kept in module state and read synchronously, because the question is asked on
 * a socket callback, outside React, where there is no time for an IPC round
 * trip before the banner is due. `true` until the shell answers - its default -
 * and `watchShellSettings` is called at startup so the answer is normally in
 * long before the first notification.
 */
let nativeNotifications = true;
let watching = false;

export function watchShellSettings(): void {
  const bridge = desktopBridge();
  if (bridge === null || watching) return;
  watching = true;
  void bridge
    .getSettings()
    .then((settings) => {
      nativeNotifications = settings.nativeNotifications;
    })
    .catch(() => undefined);
  /* The tray and the settings card can both flip it - follow them. */
  bridge.onEvent((event) => {
    if (event.type === 'settings') nativeNotifications = event.settings.nativeNotifications;
  });
}

/** `false` in a browser, and in the shell once "Native notifications" is off. */
export function shellDrawsBanners(): boolean {
  if (desktopBridge() === null) return false;
  watchShellSettings();
  return nativeNotifications;
}
